import styled from 'styled-components';

export const PrintContainer = styled.div`
  @page {
    size: A4;
  }

  .chart-wrapper,
  .barchart-wrapper {
    height: 250px;
    > div {
      height: inherit;
    }
  }

  .barchart-wrapper {
    @media print {
      canvas {
        max-width: 100%;
      }
    }
  }
`;

export const PrintBtnBanner = styled.div`
  position: fixed;
  width: 100%;
  z-index: 2;

  button {
    margin-left: auto;
  }

  @media print {
    display: none;
  }
`;

export const FullPage = styled.div`
  @media print {
    break-after: all;
    width: 210mm;
    height: calc(297mm * ${({ pages = 1 }) => pages});

    .chart-wrapper {
      margin-top: 5mm;
    }

    .chart-container {
      height: 65mm;
    }
  }
`;

export const ChartBlock = styled.div`
  @media print {
    min-height: calc(99mm * ${({ blocks = 1 }) => blocks});
  }
`;
